import React, { FC } from 'react';
import { BadgeText } from '../text/BadgeText';
import pdfStyles from '../../pdfDocument/pdfStyles';
import utils from '../utils';
import { getFontFamily } from '../../utils';
import { FONT } from '../../../../types/enums';
import { Style } from '@react-pdf/types';

type Props = {
  jobTitle: string;
  isSingleLineName: boolean;
  fontSize: number;
  styles?: Style | Style[];
};

export const BadgeJobTitle: FC<Props> = ({ jobTitle, isSingleLineName, fontSize, styles = {} }) => {
  const jobTitleTruncated = utils.getTruncatedString(jobTitle);

  return (
    <BadgeText text={jobTitleTruncated} style={[
      pdfStyles.position,
      getFontFamily(jobTitleTruncated, { fallbackFont: FONT.HELVETICA }),
      { marginTop: isSingleLineName ? 0 : 20 },
      { fontSize }, (styles as Style)]} />
  );
};
